import { CorpType } from "../../common/CommonInterfaces";
import { UserType } from "../../remoteExecution/RemoteExecutionServiceImpl";



const IsAgencyUser = ({ userType }: { userType: UserType | string }): boolean => {
	return userType === CorpType.AGENCY || userType === UserType.AGENCY_ADMIN || userType === UserType.AGENCY_STAFF || userType === UserType.AGENCY_STAFF_SCOPED;
};

const IsOrgUser = ({ userType }: { userType: UserType | string }): boolean => {
	return userType === CorpType.ORG || userType === UserType.ORG_MANAGER;
};

const IsOrgPortalUser = ({ userType }: { userType: UserType | string }): boolean => {
	return userType === CorpType.ORG
		|| userType === UserType.ORG_MANAGER
		|| userType === UserType.DIRECT_CARE_PATIENT
		|| userType === UserType.DIRECT_KIN_CARE_GIVER;
};

const IsAgencyOrOrgUser = ({ userType }: { userType: UserType | string }): boolean => {
	return IsAgencyUser({ userType }) || IsOrgUser({ userType }) || IsOrgPortalUser({ userType });
};

export { IsAgencyUser, IsOrgUser, IsOrgPortalUser, IsAgencyOrOrgUser };